import ExpandableButton from './ExpandableButton'
import SymbolIcon from './SymbolIcon'

export default function OrganizationMobileSummary({ icon, typeLabel, name, email, status, expanded, onToggle, groupExpanded, onToggleGroup, groupToggleDisabled = false }) {
  const typeIcon = (
    <span className="org-type-icon platform-mobile-type" title={typeLabel} aria-label={typeLabel}>
      <SymbolIcon icon={icon} />
    </span>
  )

  return (
    <div className="platform-mobile-heading">
      <button
        className="platform-mobile-summary"
        type="button"
        onClick={onToggle}
        aria-expanded={expanded}
      >
        <span className="platform-mobile-type-slot">{onToggleGroup ? null : typeIcon}</span>
        <span className="platform-mobile-name">{name}</span>
        <span className="platform-mobile-email">{email}</span>
        {status}
      </button>
      {onToggleGroup && (
        <ExpandableButton
          className="platform-mobile-group-toggle"
          expanded={groupExpanded}
          onClick={onToggleGroup}
          disabled={groupToggleDisabled}
          aria-label={groupExpanded ? 'Zuklappen' : 'Aufklappen'}
          title={groupExpanded ? 'Zuklappen' : 'Aufklappen'}
        >
          {typeIcon}
        </ExpandableButton>
      )}
    </div>
  )
}
